import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'src.components.LeavingTooSoonPop.header',
    defaultMessage: 'Leaving so soon?',
  },
  descriptionOne: {
    id: 'src.components.LeavingTooSoonPop.descriptionOne',
    defaultMessage: 'Looks like you were in the middle of something. We’ve automatically saved your claim progress so you can come back to it later.',
  },
  descriptionTwo: {
    id: 'src.components.LeavingTooSoonPop.descriptionTwo',
    defaultMessage: 'Looks like you were in the middle of something. If you leave now, your progress won’t be saved.',
  },
  leave: {
    id: 'src.components.LeavingTooSoonPop.leave',
    defaultMessage: 'Leave',
  },
  cancel: {
    id: 'src.components.LeavingTooSoonPop.cancel',
    defaultMessage: 'Cancel',
  },
});
